<template>    
	<div class="">
		<div class="">

		<div class="d-flex flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
				        <main class="main-wrapper flex-grow-1 with-footer">
            <div class="d-flex align-items-center bg-white">
                <div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1">
                   {{$t('45')}}
                </div>
            </div>
            <div class="divider"></div>

            <div class="container container--narrow mgt-50">
                <div class="t-subtitle6 font-r ">{{$t('46')}}</div>
                <!-- <div class="t-body1 t-color-bodyGrayA font-">{{$t('47')}}</div> -->

                <div class="mgt-24">
                    <label
                        class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined"
                        data-mdc-auto-init="MDCTextField" :id="`issueEl`">
                        <span class="mdc-text-field__ripple"></span>
                        <textarea
                            class="mdc-text-field__input t-body6 font-r  pdl-14  pdr-15 pdb-34 t-line-h-26 l-spacing2"
                            aria-labelledby="my-label-id" rows="11" cols="10" maxlength="200" v-model="contents"></textarea>
                        <span id="label" class="mdc-floating-label text-area-label">{{$t('48')}}</span>
                        <span class="mdc-line-ripple"></span>
                    </label>
                    <div class="mdc-text-field-helper-line mgr--12">
                        <div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA"></div>
                    </div>
                </div>
            </div>
        </main>
        <div class="footer bg-white bottomStack">
            <div class="divider"></div>
            <div class="container container--narrow pdb-0">
                <div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
                    <div class="d-flex align-items-center">
                    </div>
                    <div class="d-flex align-items-center">
                        <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="requestIssue()" @keypress="requestIssue()" :disabled="!checkValid" tabindex="0">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label t-body2 font-r t-nowrap">{{$t('49')}}</span>
                        </button>
                        <button class="mdc-button bg-secondary t-color-secondaryBtnText " @click="closeIssue()" @keypress="closeIssue()" >
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label t-body2 font-r t-nowrap">{{$t('50')}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
		</div>
			</div>
		</div>
		
	
</template>

<script>
/**
 * 시험 문항 이슈제기 컴포넌트(exam question issue component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import TopAppBar from '../TopAppBar.vue'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import {topAppBarMixin} from '../../mixins/topAppBar.js'
export default {
	data() {
		return {
			issueEl: null,
			contents: ''
		}
	},
	components: {
		TopAppBar,
		TopAppBarDrawer,
	   // LearnList
	},

	mixins: [topAppBarMixin],
	computed: {
		// contents 유효성 체크(validation check contents)
		checkValid() {
			return !!this.contents
		},

	},

	mounted() {
		this.issueEl = new MDCTextField(document.querySelector(`#issueEl`))
		this.setMaterialUi()
	},

	methods: {
		// 이슈 등록(regist issue)
		requestIssue() {
			let params = {
				contents: this.contents,
				examineeId: this.$route.params.examineeId,
				questionId: this.$route.params.questionId,
			}

			// call api issue regist
			examApi.issue(params).then((response) => {
				this.closeIssue()
			}).catch((err) => {
				this.closeIssue()
			})
		},

		// 이슈 등록 취소(cancel issue)
		closeIssue() {
			this.$router.go(-1)
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}
</script>